<template>
  <div ref="divGrafico" class="panel" style="height: 100%;">
    <!-- Icono mover/eliminar pildora -->
    <div :class="{ 'vue-draggable-handle glyphicon glyphicon-move': editable }"></div>
    <!-- //Icono mover/eliminar pildora -->
    <div class="panel-body bg-slate-300" style="height: 100%;" v-if="editable">
      <!-- Id de la pildora -->
      <div class="heading-elements">
        <span class="heading-text badge alpha-light">{{ formatGraficoId }}</span>
      </div>
      <!-- //Id de la pildora -->
      <div
        :class="{ 'vue-removable-handle glyphicon glyphicon-remove': editable }"
        @click="onClickEliminar()"
      ></div>
      <!-- //Icono mover/eliminar pildora -->
      <!-- Valores principales -->
      <h5 class="no-margin">Gráfico</h5>
      {{ config.name !== null && config.name !== undefined ? config.name : "" }}
      <i
        class="glyphicon glyphicon-circle-arrow-up vue-grid-grafico-editando"
      />
      <!-- //Valores principales -->
    </div>
    <GChart
      v-else
      ref="grafico"
      :type="formatTipoGrafico"
      :data="chartData"
      :options="chartOptions"
      :resizeDebounce="200"
    />
  </div>
</template>
<script>
import { GChart } from "vue-google-charts";

export default {
  props: {
    data: Object,
    config: Object,
    editable: Boolean
  },
  components: {
    GChart
  },
  data() {
    return {
      bip_item_id: Number(this.$route.query.tienda),
      graficoPorDefecto: "ColumnChart",
      chartData: [],
      chartOptions:
        this.config !== undefined && this.config.chartOptions !== undefined
          ? this.config.chartOptions
          : null
    };
  },
  watch: {
    graficoData: {
      handler(n, o) {
        if (o === undefined || n !== o) {
          this.populateChartData();
          this.setGraficoHeight();
        }
      },
      deep: true
    },
    config: {
      handler(n, o) {
        if (o === undefined || n !== o) {
          this.setConfig();
          this.setGraficoHeight();
        }
      },
      deep: true
    },
    editable: {
      handler(n, o) {
        if (n !== o) {
          this.setGraficoHeight();
        }
      },
      deep: true
    }
  },
  methods: {
    populateChartData() {
      if (this.graficoData !== undefined && this.config !== undefined) {
        if (this.chartData.length > 0) {
          while (this.chartData.length > 0) {
            this.chartData.pop();
          }
        }
        this.chartData = Array.from(this.graficoData);
      }
    },
    setConfig() {
      if (this.config !== undefined && this.config.chartOptions !== undefined) {
        this.chartOptions = this.config.chartOptions;
      }
    },
    setGraficoHeight() {
      this.chartOptions.height = this.$refs.divGrafico.clientHeight - 10;
    }
  },
  computed: {
    formatTipoGrafico() {
      if (this.config !== undefined && this.config.type !== undefined) {
        return this.config.type;
      } else {
        return this.graficoPorDefecto;
      }
    },
    formatGraficoId() {
      if (
        this.config !== undefined &&
        this.config.bip_grafico_id !== undefined
      ) {
        return `Id: ${this.config.bip_grafico_id}`;
      } else {
        return "Id: ?";
      }
    }
  }
};
</script>